<template>
    <div style="min-height: 500px">
        <!--<div class="logo"></div>-->
        <div class="maanshanLogo"></div>
        <div v-if="RegisterMethod==1">
            <Form ref="FormInline" :model="FormInline" :rules="RuleInline">
                <FormItem prop="UserName">
                    <Input type="text" v-model="FormInline.UserName" placeholder="填写用户名" size="large" />
                </FormItem>
                <FormItem prop="Password">
                    <Input type="password" v-model="FormInline.Password" placeholder="填写密码" size="large" />
                </FormItem>
                <FormItem prop="Repassword">
                    <Input type="password" v-model="FormInline.Repassword" placeholder="填写密码" size="large" />
                </FormItem>
                <FormItem prop="PhoneNum">
                    <Input type="text" v-model="FormInline.PhoneNum" placeholder="填写手机号码" size="large" />
                    <SendMsg class="sendMsg"  :fn="GetValidCode" :deftext="'获取验证码'" ref='btn' :second='60'></SendMsg>
                </FormItem>
                <FormItem prop="PhoneVaild">
                    <Input type="text" v-model="FormInline.PhoneVaild" placeholder="填写短信验证码" size="large" />
                </FormItem>
                <FormItem prop="Email">
                    <Input type="text" v-model="FormInline.Email" placeholder="填写邮箱(非必填)" size="large" />
                </FormItem>
                <FormItem>
                    <Button type="primary" long @click="HandleSubmit()">注册</Button>
                </FormItem>
            </Form>
        </div>
        <div v-else>
            <div>
                <div class="QRcodeBackground">
                    <!--<img :src="QRcode" style="width:80%;">-->
                    <!--<iframe :src="QRcode" style="height:100%;min-height:400px;width:100%;margin-top:120px;"></iframe>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SendMsg from '../components/BaseEllipsis/SendMsg.vue'
    export default {
        name: "Register",
        components:{
            SendMsg
        },
        props:["RegisterMethod"],
        data(e){
            let validatePass = function(rule, value, callback) {
                let str=/(?=.*[\d])?(?=.*[a-zA-Z])(?=.*[\d])/;
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else if(str.test(value)==false){
                    callback(new Error('密码必须包括英文和数字'));
                }else {
                    callback();
                }
            };
            let validateRepass=function(rule, value, callback) {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else if(value!=e.FormInline.Password){
                    callback(new Error('两次密码输入不一致'));
                }else {
                    callback();
                }
            };
            return {
                FormInline: {
                    UserName: '',
                    Password: '',
                    Repassword:'',
                    PhoneNum:'',
                    PhoneVaild:'',
                    Email:''
                },
                RuleInline: {
                    UserName: [
                        { message: "用户名不能为空", required: true, trigger: 'blur' },
                        { type: 'string', min: 6, message: '用户名不能小于6个字符', trigger: 'blur' }
                    ],
                    Password: [
                        { validator: validatePass, required: true,trigger: 'blur' },
                        { type: 'string', min: 8, message: '密码不能小于8个字符', trigger: 'blur' }
                    ],
                    Repassword:[
                        { validator: validateRepass,required: true, trigger: 'blur' },
                        { type: 'string', min: 8, message: '密码不能小于8个字符', trigger: 'blur' }
                    ],
                    PhoneNum: [{ required: true, trigger: 'blur',validator: function(rule, value, callback){
                            let reg = /^1[3456789]\d{9}$/;
                            if (value == '') {return callback('请填写手机号');}
                            else if (!reg.test(value)) {return callback('手机号码格式错误');}
                            else {return callback();}
                        }}],
                    PhoneVaild: [{ required: true, message: '请填写验证码', trigger: 'blur' }],
                    Email: [{ required: false, trigger: 'blur',validator:  function(rule, value, callback) {
                            let str=/^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/;
                            if(value&&str.test(value)==false){
                                callback(new Error('请填写正确的邮箱格式'));
                            }else {
                                callback();
                            }
                        }
                    }],
                },
                QRcode:'',
                Sending:false,
            }
        },
        mounted(){
            // this.GetQRcodeURL();//生成二维码
            // let timer=setInterval(this.GetQRcodeURL,20000);
            // this.$once('hook:beforeDestroy', () => {
            //     clearInterval(timer);
            // });
        },
        methods:{
            // GetQRcodeURL(){
            //     this.InApi("api/flow/flow/GetQRCodeUrl","","get").then(result => {
            //         if(result){
            //             this.QRcode=result;
            //         }
            //     })
            // },
            GetValidCode:function(){
                if(this.Sending) return;
                let _self=this;
                if(_self.FormInline.PhoneNum=="") {return;}
                if(_self.FormInline.PhoneNum.split("").length<=10){_self.$Message.error("请输入正确的手机号");return;}
                _self.$refs.btn.run();   //开始倒计时
                _self.Sending=true; //禁用重新发送按钮
                setTimeout(function(){_self.Sending=false}, 60000);
                _self.$store.commit("GetValidCode",_self.FormInline.PhoneNum);
            },
            HandleSubmit(){
                let that=this;
                that.$refs["FormInline"].validate((valid) => {
                    if (valid) {
                        let mixPass=that.FormInline.UserName+"+"+that.FormInline.Password;
                        let _password=that.$md5(mixPass);
                        let sendData={
                            S_UserFlag:that.FormInline.UserName,
                            S_ZhuCeFangShi:_password,
                            S_OpenID:"",
                            S_UserPhone:that.FormInline.PhoneNum,
                            S_UserEmail:that.FormInline.Email,
                            S_UnionID:"",
                            I_ZhuCeFangShi:"3",
                            S_YZM:that.FormInline.PhoneVaild
                        };
                        that.$store.commit("PhoneSecret", that.FormInline.PhoneNum);
                        sendData.S_UserPhone=that.$store.state.PhoneSecret.SendObj;
                        that.InApi("api/wangting/UserInfo/InsertUserInfo",sendData,"post").then(result => {
                            if(!result) return false;
                            let _data=JSON.parse(result);
                            if(_data.ReturnCode==true){
                                that.$Message.success(_data.ReturnMessage);
                                that.GotoLogin(sendData);  //调用登录方法
                            }else{
                                that.$Message.error(_data.ReturnMessage);
                            }
                        })
                    }
                })
            },
            GotoLogin(item){
                let that=this;
                let data={
                    S_UserFlag:item.S_UserFlag,
                    S_ZhuCeFangShi:item.S_ZhuCeFangShi,
                    S_UserPhone:"",
                    S_YZM:"",
                    DengLuFangShi:3
                };
                that.InApi("api/wangting/UserInfo/Login", data,"post").then(response => {
                    let res=JSON.parse(response);
                    if (res.ReturnCode == false) {
                        that.$Message.error(res.ReturnMessage);
                        return false;
                    }
                    localStorage.setItem('token', res.Token);
                    localStorage.setItem('S_UserFlag',res.ReturnData[0].S_UserFlag);
                    localStorage.setItem('S_UserPhone',res.ReturnData[0].S_UserPhone);
                    localStorage.setItem('G_Roles',res.ReturnData[0].G_Roles);
                    that.$emit('ChangeUserName',res.ReturnData[0].S_UserFlag);
                    that.$emit('CancelModal');
                    //如果没有openid则跳关注
                    if(res.ReturnData[0].S_OpenID==""){
                        that.$emit('ShowWechatModal',true);
                        return false;
                    }
                    //曾经微信公众号注册过但没完善信息的跳转
                    if(!res.ReturnData[0].S_UserFlag){
                        that.$router.push({path: 'AccountManagementList',query:{TabName:"addUserInfo"}});
                    }else if(!res.ReturnData[0].S_UserPhone){
                        that.$router.push({path: 'AccountManagementList',query:{TabName:"changePhoneNumber"}});
                    }
                    that.LocalStorage();//字典类的放storage里,如果有
                });
            },
            LocalStorage () {
                this.$store.commit("GetBaseData",2);
            },
            ResetFields(){
                this.$nextTick(function(){
                    this.$refs["FormInline"].resetFields();
                });
            }
        }
    }
</script>

<style scoped>
    .logo{width:100%;height:30px;background: url("../assets/Img/pic-logo.png") left no-repeat;}
    .maanshanLogo{width:80%;height:100px;background: url("../assets/Img/maanshan.png") center no-repeat;background-size: contain;margin:0 auto;}
    .sendMsg{position: absolute;right: 0;top:4px}
    .sendMsg:hover{
        cursor: pointer;
    }
    .QRcodeBackground{width:100%;height:350px;background: url("../assets/Img/followMe.jpg") center no-repeat;background-size: contain}
</style>